import { CategoryTabIds } from '@client/components/mylounge/banner/constants';
import { gridConfig } from '@client/config/grid';
import { Campaign } from '@shared/types/mylounge';
import { Grid, GridBlock, ColumnSize, OpenGrid, OpenSimpleGrid } from '@client/config/layout';

export const getNextGridBlock = (gridBlock: GridBlock, columnCount: number): GridBlock => ({
    w: 1,
    h: 1,
    x: (gridBlock.x + 1) % columnCount,
    y: gridBlock.x + 1 >= columnCount ? gridBlock.y + 1 : gridBlock.y,
});

export const getGridConfig = (categoryTabId: CategoryTabIds): Grid => {
    return categoryTabId === CategoryTabIds.ALL ? OpenGrid : OpenSimpleGrid;
};

export const getGrid = (
    categoryTabId: CategoryTabIds,
    columnCount: ColumnSize,
    campaignsCount: number,
): GridBlock[] => {
    const categoryGridConfig = getGridConfig(categoryTabId);
    const grid = categoryGridConfig[columnCount];

    while (grid.length < campaignsCount) {
        grid.push(getNextGridBlock(grid[grid.length - 1], columnCount));
    }

    return grid;
};

export const mergeCampaignsWithGrid = (
    campaigns: Campaign[],
    gridBlocks: GridBlock[],
): (GridBlock | (Campaign & GridBlock))[] => {
    return campaigns.map((campaign, idx) => {
        return { ...gridBlocks[idx], ...campaign };
    });
};

export const getMaxColumnHeight = (gridBlocks: GridBlock[]) => {
    let maxHeight = 0;

    gridBlocks.forEach((block: GridBlock) => {
        const sum = block.y + block.h;
        maxHeight = Math.max(sum, maxHeight);
    });

    return maxHeight;
};

export const getColumnCount = (width: number) => {
    const { gridCalculation, columns, minWidth } = gridConfig.open;

    const availableColumnCount = 1;
    for (let i = 0; i < columns.length; i++) {
        const colCount: ColumnSize = columns[i];
        const newWidth = (minWidth * 100) / gridCalculation[colCount].column;
        if (newWidth <= width) {
            return colCount;
        }
    }

    return availableColumnCount;
};
